import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {getExportShippingOrdersCSVv41} from "../../../services/api/apiBarcode"
import {getAccessToken} from "../../../services/AuthServices"

class ExportShipping extends Component {
    // FAC-24991: fetch chạy trong trang nên không còn được browser tự huỷ request cũ như
    // window.location.href trước đây. Chặn click trùng để một lần export chỉ chạy một query.
    _exporting = false

    _exportShipping = async () => {
        if (this._exporting) return
        this._exporting = true

        try {
            const {filter} = this.props
            let tagsExport = []
            if(filter.tags)  tagsExport.push(...filter.tags)
            if(filter.list_tags) tagsExport.push(...filter.list_tags)

            const {list_tags, tags, ...rest} = filter

            const cloneFilter = Object.assign({}, rest)

            delete cloneFilter['created']
            delete cloneFilter['generated']

            if(tagsExport.length > 0){
                cloneFilter['tags[]'] = tagsExport
            }

            if (filter.created.hasOwnProperty('from')) {
                cloneFilter['created[$gte]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilter['created[$lte]'] = filter.created.to
            }

            if (filter.generated.hasOwnProperty('from')) {
                cloneFilter['generated[from]'] = filter.generated.from
            }

            if (filter.generated.hasOwnProperty('to')) {
                cloneFilter['generated[to]'] = filter.generated.to
            }

            delete cloneFilter['barcodeNumber']

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilter['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilter['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            if (filter.hasOwnProperty('generate_label_config.delay_days')) {
                if (filter['generate_label_config.delay_days'].hasOwnProperty('from')) {
                    cloneFilter['generate_label_config.delay_days[from]'] = filter['generate_label_config.delay_days'].from
                    delete cloneFilter['generate_label_config.delay_days']
                }

                if (filter['generate_label_config.delay_days'].hasOwnProperty('to')) {
                    cloneFilter['generate_label_config.delay_days[to]'] = filter['generate_label_config.delay_days'].to
                    delete cloneFilter['generate_label_config.delay_days']
                }
            }

            if(filter.is_fba) {
                if(filter.is_fba === 'TikTok'){
                    cloneFilter.is_tiktok = 'y'
                    delete cloneFilter.is_fba
                }else if(filter.is_fba === 'n'){
                    cloneFilter.is_tiktok = 'n'
                }
            }

            // FAC-24991: endpoint đã yêu cầu Bearer token nên không dùng window.location.href được nữa.
            const res = await fetch(getExportShippingOrdersCSVv41({...cloneFilter}), {
                headers: {Authorization: `Bearer ${getAccessToken()}`},
            })

            if (!res.ok) {
                const {message} = await res.json().catch(() => ({}))

                throw new Error(message || `Export thất bại (${res.status})`)
            }

            const blobUrl = URL.createObjectURL(await res.blob())
            const link = document.createElement('a')

            link.href = blobUrl
            link.download = 'shipping.csv'
            document.body.appendChild(link)
            link.click()
            link.remove()
            URL.revokeObjectURL(blobUrl)
        } catch (err) {
            alert(err.message)
        } finally {
            this._exporting = false
        }
    }

    render() {
        return (
            <Button className="btn btn-warning btn-labeled btn-labeled-left ml-1" onClick={this._exportShipping}>
                <b><i className="mi-local-shipping"/></b>
                Export Shipping
            </Button>
        )
    }
}

ExportShipping.propTypes = {
    filter: PropTypes.object.isRequired
}

export default ExportShipping
